/* RESPONSIBLE TEAM: team-automation-foundations */
import Model, { attr } from '@ember-data/model';
export default class AiAgentQuickReplies extends Model {
  @attr('string') declare allDoneLabel: string;
  @attr('string') declare waitForTheTeamLabel: string;
}
